import Papa from 'papaparse'

export interface ParsedCsvRow {
  disbursementId: string
  orgName: string
  amount: string
  dateChequeCashed: string
  chequeNo: string
}

export function parseChequeReconciliationCsv(csvText: string): ParsedCsvRow[] {
  const lines = csvText.split('\n')
  const headerIndex = lines.findIndex(line => line.includes('Disbursement ID') && line.includes('Cheque Cashed'))

  if (headerIndex === -1) return []

  const csvFromHeader = lines.slice(headerIndex).join('\n')
  const { data: records } = Papa.parse<Record<string, string>>(csvFromHeader, {
    header: true,
    skipEmptyLines: true,
    transformHeader: header => header.trim()
  })

  return records
    .filter(row => row['Cheque Cashed ?']?.toUpperCase() === 'YES' && row['Marked as Paid?']?.toUpperCase() === 'NO')
    .filter(row => row['Disbursement ID']?.trim())
    .map(row => ({
      disbursementId: row['Disbursement ID'].trim(),
      orgName: row['Org Name']?.trim() ?? '',
      amount: row['Amount (USD)']?.trim() ?? '',
      dateChequeCashed: row['Date Cheque Cashed']?.trim() ?? '',
      chequeNo: row['Cheque No.']?.trim() ?? ''
    }))
}
